import { render, staticRenderFns } from "./quarterlyPrize.vue?vue&type=template&id=96db246c&scoped=true"
import script from "./quarterlyPrize.vue?vue&type=script&lang=js"
export * from "./quarterlyPrize.vue?vue&type=script&lang=js"
import style0 from "./quarterlyPrize.vue?vue&type=style&index=0&id=96db246c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96db246c",
  null
  
)

export default component.exports